<app-progress-spinner [enabled]="loading === true" />
